import { Injectable } from "@angular/core";
import { IFirebaseService } from "./firebase.service.interface";
import { FirebaseX } from "@awesome-cordova-plugins/firebase-x/ngx";
import { Observable, Subject } from "rxjs";

@Injectable()
export class FirebaseIosService implements IFirebaseService {

    constructor(private firebaseX: FirebaseX) {
        console.log('Firebase iOS Service initialized');
    }

    async getToken(): Promise<string> {
        try {
            const hasPermission = await this.hasPermission();
            
            if (!hasPermission) {
                console.log('iOS: No permission, requesting...');
                const granted = await this.grantPermission();
                
                if (!granted) {
                    throw new Error('iOS: User denied notification permissions');
                }
            }
            
            let  token = await this.firebaseX.getAPNSToken();
            console.info('iOS Firebase token:', token);
            if(token){
                return token
            }
            return await new Promise<string>((resolve, reject) => {
                const subscription = this.firebaseX.onApnsTokenReceived().subscribe({
                    next: (apnsToken: string) => {
                        console.log('Received APNs token from observable:', apnsToken);
                        subscription.unsubscribe();
                        resolve(apnsToken);
                    },
                    error: (err: any) => {
                        console.error('Error in onApnsTokenReceived:', err);
                        subscription.unsubscribe();
                        reject(err);
                    },
                });
            });
        } catch (error) {
            console.error('iOS token error:', error);
            throw error;
        }
    }

    onMessageReceived(): Observable<any> {
        return this.firebaseX.onMessageReceived();
    }

    onTokenRefresh(): Observable<string> {
        // for ios should refresh apnsToken and save to db
        const sub = new Subject<string>();
        this.firebaseX.getAPNSToken().then(apnsRefreshed=>{
            console.log('apnsRefreshed',apnsRefreshed)
            if(apnsRefreshed){
                sub.next(apnsRefreshed)
            }
        })
        return  sub.asObservable();
    }

    async grantPermission(): Promise<boolean> {
        try {
            console.log('iOS: Requesting notification permissions...');
            const granted = await this.firebaseX.grantPermission();
            
            if (granted) {
                console.log('iOS: Notification permissions granted', granted);
            } else {
                console.warn('iOS: Notification permissions denied', granted);
            }
            
            return granted;
        } catch (error) {
            console.error('iOS: Error requesting permissions:', error);
            return false;
        }
    }

    async hasPermission(): Promise<boolean> {
        try {
            const hasPermission = await this.firebaseX.hasPermission();
            console.log('iOS: Has permission:', hasPermission);
            return hasPermission;
        } catch (error) {
            console.error('iOS: Error checking permissions:', error);
            return false;
        }
    }
}